<app-graphical-view-list [projectId]="idProject" [isModal]="false"></app-graphical-view-list>
